<div
  class="empty-state"
  [class.empty-state--error]="variant() === 'error'"
  role="status"
  aria-live="polite"
>
  <i [class]="iconClass()" aria-hidden="true"></i>
  <h3 class="empty-state__title">{{ title() }}</h3>
  @if (message()) {
    <p class="empty-state__message">{{ message() }}</p>
  }
  @if (actionLabel()) {
    <button
      type="button"
      class="empty-state__action"
      (click)="action.emit()"
    >
      {{ actionLabel() }}
    </button>
  }
</div>
